<template>
    <div class="auth">
        <div class="auth-logo my-5">
            <img src="@/assets/2-1.png" />
        </div>
        <div class="auth-container d-flex justify-content-center">
            <div v-if="!loading" class="auth-wrapper p-sm-5 p-3">
                <p class="auth-title">Sign up</p>
                <div class="row w-100">
                    <div class="col-md-6 col-12">
                        <primary-input
                                type="text"
                                name="first name"
                                v-model="contact.first_name"
                                v-validate="'required'"
                                :class="{'input': true, 'is-danger': errors.has('first name')}"
                                placeholder="Enter first name"
                                class="first_name"
                        />
                        <div
                                class="help is-danger"
                                v-if="errors.has('first name')"
                        >{{ errors.first('first name') }}
                        </div>
                        <div
                                class="help is-danger"
                                v-if="contactError"
                        >{{contactError.first_name ? contactError.first_name[0] : null}}
                        </div>

                        <primary-input
                                type="text"
                                name="company name"
                                v-model="company_name"
                                v-validate="'required'"
                                :class="{'input': true, 'is-danger': errors.has('company name')}"
                                placeholder="Enter company name"
                        />
                        <div
                                class="help is-danger"
                                v-if="errors.has('company name')"
                        >{{ errors.first('company name') }}
                        </div>
                        <div
                                class="help is-danger"
                                v-if="companyError"
                        >{{contactError.company_name ? contactError.company_name[0] : null}}
                        </div>

                        <primary-input
                                type="text"
                                name="phone number"
                                v-model="contact.phone"
                                v-validate="'required'"
                                :class="{'input': true, 'is-danger': errors.has('phone number')}"
                                placeholder="Enter phone number"
                        />
                        <div
                                class="help is-danger"
                                v-if="errors.has('phone number')"
                        >{{ errors.first('phone number') }}
                        </div>
                        <div
                                class="help is-danger"
                                v-if="contactError"
                        >{{contactError.phone_number ? contactError.phone_number[0] : null}}
                        </div>


                        <!--            country & state-->
                        <div class="select_div">
                            <div class="">
                                <primary-select
                                        type="text"
                                        name="country"
                                        v-validate="'required'"
                                        v-model="contact.country_uuid"
                                        :class="{'input': true, 'is-danger': errors.has('country')}"
                                        placeholder="Enter country"
                                >
                                    <option
                                            v-for="(country, index) in country_list"
                                            :value="country.country_uuid"
                                            :key="index"
                                    >{{country.nice_name ? country.nice_name : country.name}}
                                    </option>
                                </primary-select>
                                <div
                                        v-if="errors.has('country')"
                                        class="help is-danger"
                                >{{ errors.first('country') }}
                                </div>
                                <div
                                        class="help is-danger"
                                        v-if="contactError"
                                >{{contactError.country ? contactError.country[0] : null}}
                                </div>
                            </div>
                            <div class="">
                                <primary-input
                                        type="text"
                                        name="state"
                                        v-model="contact.state"
                                        v-validate="'required'"
                                        :class="{'input': true, 'is-danger': errors.has('state')}"
                                        placeholder="Enter state"
                                />
                                <div v-if="errors.has('state')" class="help is-danger">{{ errors.first('state') }}</div>
                                <div
                                        class="help is-danger"
                                        v-if="contactError"
                                >{{contactError.state ? contactError.state[0] : null}}
                                </div>
                            </div>
                        </div>

                        <!--            password-->
                        <primary-input
                                type="password"
                                name="password"
                                autocomplete="off"
                                v-model="contact.passwd"
                                v-validate="'required'"
                                ref="password"
                                :class="{'input': true, 'is-danger': errors.has('password')}"
                                placeholder="********"
                        />
                        <div v-if="errors.has('password')" class="help is-danger">{{ errors.first('password') }}</div>
                        <div
                                class="help is-danger"
                                v-if="contactError"
                        >{{contactError.password ? contactError.password[0] : null}}
                        </div>
                    </div>

                    <!--          last name-->
                    <div class="col-md-6 col-12">
                        <primary-input
                                type="text"
                                name="last name"
                                v-model="contact.last_name"
                                v-validate="'required'"
                                :class="{'input': true, 'is-danger': errors.has('last name')}"
                                placeholder="Enter last name"
                                class="first_name"
                        />
                        <div
                                v-if="errors.has('last name')"
                                class="help is-danger"
                        >{{ errors.first('last name') }}
                        </div>
                        <div
                                class="help is-danger"
                                v-if="contactError"
                        >{{contactError.last_name ? contactError.last_name[0] : null}}
                        </div>


                        <!--            email-->
                        <primary-input
                                name="email"
                                type="text"
                                v-model="contact.email"
                                v-validate="'required'"
                                :class="{'input': true, 'is-danger': errors.has('email')}"
                                placeholder="Enter Email"
                        />
                        <div v-if="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</div>
                        <div
                                class="help is-danger"
                                v-if="contactError"
                        >{{contactError.email ? contactError.email[0] : null}}
                        </div>


                        <!--            address-->
                        <primary-input
                                type="text"
                                name="address"
                                v-model="contact.address"
                                v-validate="'required'"
                                :class="{'input': true, 'is-danger': errors.has('address')}"
                                placeholder="Enter address"
                        />
                        <div v-if="errors.has('address')" class="help is-danger">{{ errors.first('address') }}</div>
                        <div
                                class="help is-danger"
                                v-if="contactError"
                        >{{contactError.address ? contactError.address[0] : null}}
                        </div>

                        <div class="select_div">
                            <div class="">
                                <primary-input
                                        type="text"
                                        name="city"
                                        v-model="contact.city"
                                        v-validate="'required'"
                                        :class="{'input': true, 'is-danger': errors.has('city')}"
                                        placeholder="Enter city"
                                />
                                <div v-if="errors.has('city')" class="help is-danger">{{ errors.first('city') }}</div>
                                <div
                                        class="help is-danger"
                                        v-if="contactError"
                                >{{contactError.city ? contactError.city[0] : null}}
                                </div>
                            </div>
                            <div class="">
                                <primary-input
                                        type="text"
                                        name="zip code"
                                        v-model="contact.zipcode"
                                        v-validate="'required'"
                                        :class="{'input': true, 'is-danger': errors.has('zip code')}"
                                        placeholder="Zip code"
                                />
                                <div
                                        v-if="errors.has('zip code')"
                                        class="help is-danger"
                                >{{ errors.first('zip code') }}
                                </div>
                                <div
                                        class="help is-danger"
                                        v-if="contactError"
                                >{{contactError.zip_code ? contactError.zip_code[0] : null}}
                                </div>
                            </div>
                        </div>


                        <!--            re-enter password-->
                        <primary-input
                                type="password"
                                autocomplete="off"
                                name="re-enter password"
                                v-validate="'required|confirmed:password'"
                                data-vv-as="password"
                                v-model="checkPassowrd"
                                :class="{'input': true, 'is-danger': errors.has('re-enter password')}"
                                placeholder="********"
                        />
                        <div
                                class="help is-danger"
                                v-if="errors.has('re-enter password')"
                        >{{ errors.first('re-enter password') }}
                        </div>
                        <div
                                class="help is-danger"
                                v-if="contactError"
                        >{{contactError.re-enter_password ? contactError.re-enter_password[0] : null}}
                        </div>
                    </div>
                </div>

                <div class="auth-nav-container px-3">
                    <primary-button @click.native="register">Sign Up</primary-button>
                    <span>
            Have an account?
            <a @click="$router.push({name: 'login'})" class="link">Log In</a>
          </span>
                </div>
            </div>
            <loader :loading="loading" v-if="loading"/>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import filter from "../../store/modules/admin/filter";

    export default {
        components: {
            PrimaryInput: () => import("../../components/Inputs/PrimaryInput.vue"),
            PrimarySelect: () => import("../../components/Inputs/PrimarySelect.vue"),
            PrimaryButton: () => import("../../components/Buttons/PrimaryButton.vue"),
            Loader: () => import("@/components/Loader.vue"),
        },
        data: () => ({
            companyError: null,
            contactError: null,
            loading: false,
            country_list: [],
            products: [],
            items: "",
            contact: {
                zipcode: null,
                email: null,
                city: null,
                phone: null,
                state: null,
                country_uuid: null,
                products: [],
                last_name: null,
                passwd: null,
                full_name: null,
                first_name: null,
                address: null,
            },
            company_name: null,
            checkPassowrd: null,
            product_list: [],
        }),
        created() {
            this.$store.dispatch("getCountryList", {}).then((res) => {
                this.country_list = res.items;
            });

            axios({
                url: "/public/product/list?status=active",
                method: "GET",
            }).then((res) => {
                this.products = res.data.payload.items;
                console.log(this.contact.products);
            });
        },

        methods: {
            productChanged(v) {
                if (!this.contact.products.includes(v)) {
                    let selectItem = this.products.filter((item) => item.product_uuid == v);
                    this.items = ''
                    this.items =
                        this.items !== ""
                            ? selectItem[0].product_name + ", " + this.items
                            : selectItem[0].product_name + " " + this.items;
                    this.contact.products = [...this.contact.products, v];
                }
            },
            register() {
                this.$validator.validate().then((result) => {
                    if (result) {
                        this.loading = true;
                        this.$store
                            .dispatch("registration", {
                                contact: this.contact,
                                company_name: this.company_name,
                            })
                            .then(() => {
                                this.$snotify.success("Confirmation email was sent.", {
                                    timeout: 12000,
                                });
                                this.loading = false;
                                this.$router.push({name: "login"});
                            })
                            .catch((err) => {
                                this.loading = false;
                                if (err.errors) {
                                    this.companyError = err.errors[0].company_name
                                        ? err.errors[0].company_name[0]
                                        : null;
                                    this.contactError = err.errors[0].contact
                                        ? err.errors[0].contact
                                        : null;
                                    setTimeout(() => {
                                        this.companyError = null;
                                        this.contactError = null;
                                    }, 6000);
                                } else {
                                    this.$snotify.error(err.error.message, {
                                        timeout: 6000,
                                    });
                                }
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    }
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .select_div {
        display: grid;
        grid-template-columns: repeat(auto-fit, 48%);
        grid-gap: 4%;
    }

    .auth {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 100%;
        min-height: 100vh;

        .auth-container {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .auth-wrapper {
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 650px;
                border-radius: 4px;
                background-color: #ffffff;
                box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

                .col-wrapper {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;

                    .col-sm {
                        width: 49%;
                        padding-left: 0;
                    }

                    .col {
                        width: 48%;

                        .input {
                            margin-bottom: 20px;
                        }
                    }
                }

                .row .input {
                    margin-bottom: 20px;
                }

                .auth-title {
                    color: #000000;
                    font-family: "Helvetica Neue";
                    font-size: 24px;
                    font-weight: bold;
                    line-height: 24px;
                    text-align: center;
                    margin-bottom: 30px;
                }

                .email-input {
                    margin-bottom: 20px;
                }

                .password-input {
                    margin-bottom: 30px;
                }

                .auth-nav-container {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;

                    .link {
                        color: #51a3f3;
                    }

                    button {
                        width: 100px;
                        height: 40px;
                    }

                    span {
                        color: #55616e;
                        font-family: "Helvetica Neue";
                        font-weight: 400;
                        font-size: 16px;
                        line-height: 20px;
                    }
                }

                .first {
                    margin-bottom: 30px;

                    .remember-me {
                        display: flex;
                        align-items: center;

                        input {
                            margin-right: 5px;
                        }
                    }
                }
            }
        }
    }
</style>

